/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  response: Object,
};

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class DisableAccountMultiSuccess extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const { currentAccountDetails, response }: TypeProps = this.props;

    const accountsDisabled: Array<string> = toJS(response['success-disabled'])
      .map(r => `${r.name} - ${r.account_no}`)
      .map(account => <li key={account}>{account}</li>);

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:trading_accounts.multiple_disabled')}</h3>
            <p>{t('general:trading_accounts.messages.multiple_disabled')}</p>
          </div>
          <div className={styles['disable-account-details']}>
            <React.Fragment>
              <ul>{accountsDisabled}</ul>
            </React.Fragment>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
